import type { ApiError } from '@/types/common/api.type';

export function createSafeApiCall() {
    return async function safeApiCall<T>(fn: () => Promise<T>): Promise<T> {
        try {
            return await fn();
        } catch (err) {
            const apiError = err as ApiError;

            throw apiError;
        }
    };
}
